module.exports = __webpack_public_path__ + "static/media/FCW_logo.5fc6926c.svg";